module.exports = __webpack_public_path__ + "img/EVENT.5049947d.svg";